module.exports = __webpack_public_path__ + "static/media/Success.9d62b5cf.svg";